import activityFeedbackDialogSlice from './activityFeedbackDialogSlice';
import shapefileUploadDialogSlice from './shapefileUploadDialogSlice';

const dialogsSlices = [shapefileUploadDialogSlice, activityFeedbackDialogSlice];

export default dialogsSlices;
